import { createContext, useContext } from 'react';

export type FieldActions = Record<string, Function>;

export interface FieldActionsContextValue<T extends FieldActions> {
  actions?: T;
  formId?: string;
  inProgress?: boolean;
}
export const FieldActionsContext = createContext<
  FieldActionsContextValue<FieldActions>
>({});

export function useFieldActions() {
  return useContext(FieldActionsContext);
}
